import { useMutation, useQueryClient } from "@tanstack/react-query";
import galleriesAPI from "../../api/galleries/api";

export function useUpdateGallery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: galleriesAPI.updateGallery,
    onSuccess: (data, variables) => {
      // Invalidate and refetch galleries list
      queryClient.invalidateQueries({ queryKey: ["galleries"] });

      // Update specific gallery in cache
      queryClient.setQueryData(["galleries", variables.id], data);
    },
    onError: (error) => {
      console.error("Update gallery failed:", error);
    },
  });
}
